export default {
    created() {
        this.$root.$on('scrollbarScrollerPushId', this.scrollbarScrollerPush)
    },
    beforeCreate() {
        this.$root.$off('scrollbarScrollerPushId', this.scrollbarScrollerPush)
    },
    methods: {
        scrollbarScrollerPush(scrollbar, percent = 100) {
            if (scrollbar && scrollbar.$el) {
                let scrollerEl = scrollbar.$el,
                    valPx = this.scrollerPxToPercent(scrollerEl, percent)
                scrollerEl.scrollTop = valPx

                scrollbar.ps.update()

                setTimeout(() => {
                    scrollbar.ps.update()
                }, 300)
                setTimeout(() => {
                    scrollbar.ps.update()
                }, 500)
            }
        },
        scrollerPxToPercent(scroller, scrollTop) {
            let height = scroller.clientHeight,
                scrollHeight = scroller.scrollHeight - height,
                percent = Math.floor((scrollTop * scrollHeight) / 100)
            return percent
        },
        scrollLoadAllow(e, direction = 'down') {
            const scroller = e.target
            let height = scroller.clientHeight,
                scrollHeight = scroller.scrollHeight - height,
                scrollTop = scroller.scrollTop,
                percent = Math.floor((scrollTop / scrollHeight) * 100)

            if (direction === 'down') {
                if (percent >= 100) {
                    return true
                }
            } else if (percent <= 0) {
                return true
            }
        }
    }
}
